<div class="status-badge large_icon cta" [ngClass]="{ 'small': small }" *ngIf="hasCustomerCommentAlert">
  <span class="icon-heads-up-outline"></span>
  <div class="hover-text">Kommentar från kund</div>
</div>
